// extracted by mini-css-extract-plugin
export default {"dropdownsContainer":"dropdownsContainer-_mVaW","dropdownsLabel":"dropdownsLabel-UQEsh","letterTypeDropdown":"letterTypeDropdown-NPUZM","languageDropdown":"languageDropdown-URhTG"};